export default __webpack_public_path__ + "static/media/TitilliumWeb-Regular.522ebad2.ttf";